import { useHistory, useParams } from 'react-router-dom';
import ArrowIcon from '../../../assets/images/blogForm/arrowIcon';
import LoaderProfile from './loaderProfileInfo';
interface IParams {
  blogId: string;
}

const FullLoader = () => {
  const { push } = useHistory();
  const { blogId }: IParams = useParams();

  return (
    <div className="boxBlogs">
      <div className="backContainer">
        <div
          className="arrowContainer"
          onClick={() => {
            push('/blog/list');
          }}
        >
          <ArrowIcon />
        </div>
        <div className="textBack">Listado</div>
      </div>
      <div className="containerTitleBlog">
        <div className="titleBlog">{blogId ? `Publicación #${blogId}` : 'Nueva publicación'}</div>
        <div className="floatDate">
          <div className="textDate" style={{ color: 'white' }}>
            <strong> Fecha de publicación</strong> <br /> 18/09/22
          </div>
        </div>
      </div>
      <div className="firstForm">
        <div className="firstSection">
          <div className="spaceSection">
            <div className="mediumItems mr-5">
              <div className="labelItem" style={{ color: 'white' }}>
                Categoría
              </div>
              <div className="boxItem animationLoader rounded-md"></div>
            </div>
            <div className="mediumItems">
              <div className="labelItem" style={{ color: 'white' }}>
                Título de la publicación
              </div>
              <div className="boxItem animationLoader rounded-md"></div>
            </div>
          </div>
          <div className="spaceSection mt-2">
            <div className="spaceTextArea">
              <div className="labelItem" style={{ color: 'white' }}>
                Descripción corta
              </div>
              <div className="boxTextArea animationLoader rounded-md"></div>
            </div>
          </div>
          <LoaderProfile />
        </div>
        <div className="secondSection">
          <div className="boxUploadImg">
            <div className="firstImgBox">
              <div className="containerImg">
                <div className="noImg animationLoader rounded-md"></div>
              </div>
            </div>
            <div className="titleFirsImg" style={{ color: 'white' }}>
              Imagen de thumbnail
              <span className="text-nudos-gray-400" style={{ color: 'white' }}>
                {' '}
                (280x140px)
              </span>
            </div>
            <div className="boxLine">
              <div className="grayLine"></div>
            </div>
            <div className="secondImgBox">
              <div className="containerImg">
                <div className="noImg animationLoader rounded-md"></div>
              </div>
            </div>
            <div className="titleFirsImg" style={{ color: 'white' }}>
              Imagen principal
              <span className="text-nudos-gray-400" style={{ color: 'white' }}>
                {' '}
                (580x200px)
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="secondForm">
        <div className="titleSecond" style={{ color: 'white' }}>
          Cuerpo
        </div>
        <div className="containerHtmlElement animationLoader rounded-md"></div>
      </div>
    </div>
  );
};

export default FullLoader;
